import http from '@/lib/http';
import { cmsPagesEditorPath, cmsPagesPublishedPageSearchPath } from '@/lib/routes';
import type { Page, RawPageFromApi } from '@/types/page';
import { PageType } from '@/types/page';

export function normalizePageType(pageType: string | undefined | null): PageType {
  if (!pageType) {
    return PageType.BLANK;
  }

  const normalizedType = pageType.toLowerCase();
  const validPageTypes = Object.values(PageType) as string[];

  return (validPageTypes.includes(normalizedType) ? normalizedType : PageType.BLANK) as PageType;
}

export function normalizePages(pages: RawPageFromApi[]): Page[] {
  return pages.map((page) => ({
    id: String(page.id),
    path: String(page.path ?? ''),
    title: String(page.title),
    pageType: normalizePageType(page.pageType),
    isPublished: Boolean(page.isPublished ?? false),
    isNav: Boolean(page.isNav ?? false),
    pinned: Boolean(page.pinned ?? false),
    hasUnpublishedChanges: Boolean(page.hasUnpublishedChanges ?? false),
    scheduledPublishAt: page.scheduledPublishAt ?? null,
    aiContentGenerationStatus: page.aiContentGenerationStatus ?? undefined,
    navigationTitle: page.navigationTitle ? String(page.navigationTitle) : undefined,
    parentId: page.parentId == null ? null : String(page.parentId),
    url: cmsPagesEditorPath(String(page.id)),
    children: Array.isArray(page.children)
      ? normalizePages(page.children as RawPageFromApi[])
      : undefined,
  }));
}

export async function fetchPublishedPages(
  searchQuery: string = '',
  options: { includePageId?: string } = {},
): Promise<Page[]> {
  const normalizedSearchQuery = searchQuery.trim();
  const response = await http.get(cmsPagesPublishedPageSearchPath(), {
    params: {
      ...(normalizedSearchQuery
        ? { q: { titleOrNavigationTitleICont: normalizedSearchQuery } }
        : {}),
      ...(options.includePageId ? { includePageId: options.includePageId } : {}),
    },
  });

  return normalizePages((response.data.data || []) as RawPageFromApi[]);
}
